import CareerHistory from "./CareerHistory";
export default CareerHistory;
